import { createStore as _createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import baseReducers from './Reducers'
import Registry from './Registry/Registry'
import registryMiddleware from './Registry/Middleware'
import { createLogger } from 'redux-logger'
import persistState from 'redux-localstorage';
import { middleware as idleMiddleware } from '../Screens/TimerInactividad/components/TimerInactividad';
import storageSizeMiddleware from './StorageSizeMiddleware';

export default function createStore(initialState = {}) {
    const env = process.env.NODE_ENV;
    let middleWareTools = undefined;

    //Creo redux-logger.
    const logger = createLogger({
        collapsed: true,
        level: 'log',
        diff: true
    });

    //Obtengo el registry con los reducers de Portico.
    const registry = new Registry(baseReducers);

    //middlewareTools para prod.
    if (env === 'production') {
        middleWareTools = compose(
            applyMiddleware(idleMiddleware, registryMiddleware(registry), thunkMiddleware),
            persistState(null, { 
                key: 'portico',
                slicer: (paths) => (state) => {
                    // Excluir arrays grandes que pueden causar QuotaExceededError
                    const newState = { ...state };
                    if (newState.asientosContables) {
                        const { arrayResultadoBusquedaAsientos, datosExcelAsientosContables, ...restAsientosContables } = newState.asientosContables;
                        newState.asientosContables = restAsientosContables;
                    }
                    return newState;
                }
            })
        );
    //middlewareTools para dev.
    } else {
        middleWareTools = compose(
            applyMiddleware(idleMiddleware, registryMiddleware(registry), thunkMiddleware, /* logger, storageSizeMiddleware */),
            persistState(null, { 
                key: 'portico',
                slicer: (paths) => (state) => {
                    // Excluir arrays grandes que pueden causar QuotaExceededError
                    const newState = { ...state };
                    if (newState.asientosContables) {
                        const { arrayResultadoBusquedaAsientos, datosExcelAsientosContables, ...restAsientosContables } = newState.asientosContables;
                        newState.asientosContables = restAsientosContables;
                    }
                    return newState;
                }
            })
        );
    }

    let finalCreateStore = middleWareTools;

    const store = finalCreateStore(_createStore)(
        registry.initialReducers,
        initialState
    )

    registry.store = store

    return store
}


// WEBPACK FOOTER //
// ./Portico/App/store/Store.js